var exports = {
  "n": "x2b2fbebb--b925b6--link",
};

module.exports = exports;
